module.exports = __webpack_public_path__ + "img/trophy3.e2e9c1ab.svg";